import { render, staticRenderFns } from "./UserLocationSectionModule.vue?vue&type=template&id=ecc0e84c&"
import script from "./UserLocationSectionModule.vue?vue&type=script&lang=js&"
export * from "./UserLocationSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports